import Model from '@tripian/model';
import IFavoritePoi from '../../models/IFavoritePoi';
import IStepAlternatives from '../../models/IStepAlternatives';

interface ITripState {
  // Trip Data
  reference?: Model.TripReference;
  plans?: Model.Plan[];

  // Relational Data
  alternatives?: IStepAlternatives[];
  favorites?: IFavoritePoi[];
  reactions?: Model.UserReaction[];
  reservations?: Model.UserReservation[];

  // Loadings
  loading: { reference: boolean; plans: boolean; alternatives: boolean; favorites: boolean; reactions: boolean; reservations: boolean };

  // Errors
  errors: { id: number; functionName: string; title: string; message: string; hide: boolean }[];
}

export default ITripState;

export const initialTripState: ITripState = {
  // Trip Data
  reference: undefined,
  plans: undefined,

  // Relational Data
  alternatives: undefined,
  favorites: undefined,
  reactions: undefined,
  reservations: undefined,

  // Loadings
  loading: { reference: false, plans: false, alternatives: false, favorites: false, reactions: false, reservations: false },

  // Errors
  errors: [],
};
